import { BackIcon } from "@/components/icons/back-icon";
import IconButton from "@/components/ui/buttons/IconButton";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { cn } from "@/utils/cn";
import { useIonRouter } from "@ionic/react";
import { memo } from "react";

interface BackButtonProps {
  isStepRoute?: boolean;
  onBack?: () => void;
  className?: string;
}

export const BackButton = memo(function BackButton({
  isStepRoute,
  onBack,
  className,
}: BackButtonProps) {
  const navigation = useIonRouter();
  const { info } = useStepRouteInfo();

  const onBackClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (isStepRoute) {
      if (!info?.previousPath) return;
      navigation.push(info.previousPath, "none", "pop", undefined);
      return;
    }
    if (onBack) {
      onBack();
    } else {
      navigation.goBack();
    }
  };
  return (
    <IconButton aria-label="Go back" className={cn("shrink-0", className)} onClick={onBackClick}>
      <BackIcon />
    </IconButton>
  );
});
